/* eslint-disable */

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "BasicResult": [
      "BasicError",
      "BasicSuccess"
    ],
    "IError": [
      "BasicError",
      "WrongPermissions"
    ],
    "IPage": [
      "ArticlesPage"
    ],
    "IPageItem": [
      "Article"
    ],
    "IReason": [
      "PrerequisiteLevelReason",
      "PrerequisiteMissionReason",
      "StartTimeReason",
      "UnknownReason"
    ],
    "LoginActionResult": [
      "ActionRateExceeded",
      "BasicError",
      "LoginActionSuccess",
      "WrongPermissions"
    ],
    "MissionLockedReason": [
      "MultipleReasons",
      "PrerequisiteLevelReason",
      "PrerequisiteMissionReason",
      "StartTimeReason",
      "UnknownReason"
    ],
    "Reward": [
      "Badge",
      "Point",
      "Sweepstake"
    ],
    "TasksUnion": [
      "ClickableLink",
      "ExternalTask",
      "Quiz",
      "Video"
    ]
  }
};
      export default result;
    